import { Component } from '@angular/core';

@Component({
  selector: 'cf-storybook-shell-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
